import { render, staticRenderFns } from "./AffilieInternational.vue?vue&type=template&id=f38806e2&"
import script from "./AffilieInternational.vue?vue&type=script&lang=js&"
export * from "./AffilieInternational.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports